export * from './enums';
export * from './interfaces';
export * from './types';


export const konamiCodeSequence = ['DPadUp', 'DPadUp', 'DPadDown', 'DPadDown', 'DPadLeft', 'DPadRight', 'DPadLeft', 'DPadRight', 'B', 'A'];